
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/smart-chains/tutorials/create-a-default-smart-chain",
      function () {
        return require("private-next-pages/docs/smart-chains/tutorials/create-a-default-smart-chain/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/smart-chains/tutorials/create-a-default-smart-chain"])
      });
    }
  